<template>
    <div role="tablist" class="text-left">
        <faq-item id='1' question="What is Therapeutic Color Indicator?">
            <p>
                Therapeutic Color Indicator is a website that enables investigation and testing of the use of color to
                assist patients with migraine, seizure disorder and people with minor traumatic brain injury.
            </p>
            <p>
                Therapeutic Color Indicator is FREE for the optometric community and enables performance of color
                testing
                without expensive device(s). The implementation is directed by and based on the work of Dr. Paul Harris.
            </p>
        </faq-item>
        <faq-item id='2' question="How do I calibrate my screen for the best results?">
            <p>
                For the <b>best and most</b> consistent color accuracy your monitor must be calibrated.
                Whether you are using a desktop, a laptop or a tablet you can greatly enhance the accuracy of the tests by
                periodically calibrating.
                There are a number of affordable usb-connected calibration devices on the market but here are a couple of suggestions:
            </p>
            <ul>
                <li>
                    <a href="https://www.amazon.com/Datacolor-SpyderX-Pro-Calibration-Photographers/dp/B07M6KPJ9K/ref=sr_1_1?dchild=1&keywords=Datacolor+SpyderX+Pro&qid=1586828538&s=baby-products&sr=8-1"
                       target="_blank">Datacolor SpyderX Pro</a></li>
                <li>
                    <a href="https://www.amazon.com/X-Rite-ColorMunki-CMUNDIS-Accuracy-Calibration/dp/B0055MBQOM/ref=sr_1_1?dchild=1&keywords=X-Rite+ColorMunki+Display&qid=1586828574&sr=8-1"
                       target="_blank">X-Rite ColorMunki Display (CMUNDIS)</a></li>
            </ul>

            <p>
                You can easily purchase these devices on Amazon, BestBuy, Walmart, etc...
            </p>
        </faq-item>
        <faq-item id='3' question="Is Therapeutic Color Indicator FREE?">
            Therapeutic Color Indicator is FREE. Thank you for using it! Please do not hesitate to report bugs and
            ideas for improvements by emailing TherapeuticColorIndicator@gmail.com!
        </faq-item>
        <faq-item id='4' question="Is Therapeutic Color Indicator HIPAA Compliant?">
            Therapeutic Color Indicator does <b>NOT</b> store any Personally Identifiable Information therefore there are no
            Health Insurance Portability and Accountability Act (HIPAA) concerns.
        </faq-item>
        <faq-item id='5' question="Where are the test reports saved?">
            <p>
                Only the last 10 test reports are stored in the browser's <a
                    href="https://en.wikipedia.org/wiki/Web_storage#Local_and_session_storage" target="_blank">local
                storage</a>. These can be accessed by clicking
                <router-link to="/history" class="btn btn-outline-primary mr-1">
                    <i class="fas fa-history"></i> Recent Tests
                </router-link>
                on the header. Since Personally Identifiable Information is never stored you can
                only
                reference a report by the date/time it was generated.
            </p>
            <p>
                Please keep in mind that if you switch your browser, computer/device or clear the browser's local storage
                then
                the history will not exist. <b>We strongly suggest printing the report to PDF and saving it with your patient's
                records.</b>
            </p>
        </faq-item>
        <faq-item id='6' question="Does it work on a tablet or a mobile phone?">
            <p>
                Both tablets and mobile phones are supported. However, for the best results we suggest using a computer,
                a laptop
                or a tablet.
            </p>
            <p>
                No matter what device you use please do not forget to calibrate your screen. Please see <i>"How do I
                calibrate my screen for the best results?"</i> question.
            </p>
        </faq-item>
        <faq-item id='7' question="Where is the User Agreement?">
            <p>Here is the link to the <router-link to="/agreement" data-cy="faqUserAgreementLink">User Agreement</router-link>.</p>
        </faq-item>
        <faq-item id='8' question="How can I contact you?">
            <p>For the optometric related questions please contact Dr. Paul Harris at Paul.HarrisOD@gmail.com.</p>
            <p>To request a feature or to report a bug about the application please email Dima May at
                TherapeuticColorIndicator@gmail.com</p>
        </faq-item>
    </div>
</template>

<script>
    import FaqItem from "./FaqItem";

    export default {
        name: "Faq",
        components: {FaqItem},
    }
</script>

<style scoped>

</style>
